
<main>
   
    <div class="centered">
        <div class='row row-editor editors-holder'>
           
            <div class="editor-container" id="editor-container">
                <ckeditor class="editor-container full-container" [disabled]="accessType === 1"  [editor]="Editor" [config]="editorConfig" [(ngModel)]="data" (ngModelChange)="onDataChange()" 
                (keyup)="onKeyUp()"></ckeditor>
                <!-- <div class="sidebar sidebar-container" id="sidebar-container" #sidebar></div> -->
            </div>
            <!-- <div id="revision-viewer-container">
                <div class="editor-container">
                    <div id="revision-viewer-editor"></div>
                    <div class="sidebar-container" id="revision-viewer-sidebar"></div>
                </div>
            </div> -->
        </div>
    </div>
</main>